import { render, staticRenderFns } from "./CreateShift.vue?vue&type=template&id=0036c033"
import script from "./CreateShift.vue?vue&type=script&lang=js"
export * from "./CreateShift.vue?vue&type=script&lang=js"
import style0 from "./CreateShift.vue?vue&type=style&index=0&id=0036c033&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports